const trim = (value: string) => value?.trim();

export default trim;
